// extracted by mini-css-extract-plugin
export default {"steps":"CertificateSider_steps__2xtnx","loader":"CertificateSider_loader__L2h56","uploadContainer":"CertificateSider_uploadContainer__8QC7l"};